// @flow
import type {UserAgentDeviceFlags} from '../../../server/utils/systemData';
import mapActions from '../../actions/map';
import {updateJSONItem} from '../../utils/localStorageWrapper';
import haWrapper from '../../utils/haWrapper';
import {sendCustomAnalytics} from '../../utils/loadTimeAnalyticsWrapper';
import {LIST_VIEW} from '../../constants/views';
import {isEqual} from 'lodash';

import type {Store} from '../../reducers';

const MEASURE_NAME = 'search.searchMap.rendered';

export function userAgentDidChange(
    store: Object,
    action: {type: string, payload: UserAgentDeviceFlags}
) {
    if (action.payload.isDesktop) {
        store.dispatch(mapActions.enableSearchOnMove());
    } else {
        store.dispatch(mapActions.disableSearchOnMove());
    }
}

let debouncedSyncMapMarkersToLocalStorage;
export function syncMapMarkersToLocalStorage(store: Object) {
    clearTimeout(debouncedSyncMapMarkersToLocalStorage);
    debouncedSyncMapMarkersToLocalStorage = setTimeout(() => {
        const markersClicked = store.getState().map.mapMarkersClicked;
        const markersClickedKeys = Object.keys(markersClicked);
        markersClickedKeys.forEach((listingId) => {
            let marker = markersClicked[listingId];
            if (!marker.clicked) {
                marker.clicked = true; // prevent further processing
                // Write new pin to localStorage
                updateJSONItem({
                    itemKey: 'serpMapMarkers',
                    itemAttributeKey: listingId,
                    itemAttributeValue: {clicked: true},
                    shouldAddTimestamp: true
                });
            }
        });
    }, 200);
}

export function mapLoaded() {
    const {userTiming} = haWrapper;
    const alreadyMeasured =
        userTiming.getEntriesByName(MEASURE_NAME, 'measure').length > 0;
    if (!alreadyMeasured) {
        userTiming.markAndMeasureAndSend(MEASURE_NAME);
        sendCustomAnalytics(MEASURE_NAME, 'mark', (analytics) => ({
            searchMapRendered: Math.ceil(analytics.startTime)
        }));
    }
}

export function resetToInitialBounds(
    store: Store,
    action: {type: string, payload: Object}
) {
    const {query} = action.payload;

    if (query && query.view && query.view === LIST_VIEW) {
        const {
            map: {bounds, initialBounds}
        } = store.getState();
        if (!isEqual(initialBounds, bounds)) {
            store.dispatch(mapActions.mapResetSearchButton());
            store.dispatch(mapActions.mapResetToInitialBounds());
        }
    }
}
